<!-- 微信通知换绑手机号页面 -->
<template>
  <div class="content">
    <aside class="aside_1">
      <div class="title">
        <h1>微信通知升级-绑定手机号</h1>
        <p>带来多样性的微信通知模版</p>
        <p>日调用上限为10万次</p>

        <div class="inp-box">
          <input
            disabled
            oninput="if(value.length>11)value=value.slice(0,11)"
            placeholder="请联系客服绑定号码"
            style="
              border: 1px solid red;
              color: red;
              font-size: 18px;
              width: 190px;
              height: 50px;
              padding: 0 10px;
            "
            v-model="phone"
            clear
          />
          <button @click="inputBtn" class="button">提交</button>
        </div>
      </div>
    </aside>

    <!-- 弹出层 -->
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper">
        <!-- <div class="block">
          <img src="../image/open_wx.jpg" alt="" style="width: 100%" />
        </div> -->
      </div>
    </van-overlay>
    <footer>
      <div>
        © 上海致善阔贤科技有限公司｜沪ICP备2022008612号-1 <br />Copyright © 2024
        shzskx.cn All Rights Reserved.
      </div>
    </footer>
  </div>
</template>

<script>
import { setPhone } from "@/services/login.js";
import { Toast, Dialog } from "vant";
import { useWxCode } from "@/services/login.js";
window.addEventListener("pageshow", function(e) {
  // 通过persisted属性判断是否存在 BF Cache
  if (e.persisted) {
    location.reload();
  }
});
export default {
  data() {
    return {
      userInfo: {},
      phone: "",
      show: false,
    };
  },
  async created() {
    let userInfo = await useWxCode();
    if (userInfo?.code === 200) {
      this.userInfo = userInfo.data;
      this.phone = userInfo.data?.phone;
    }
  },
  methods: {
    inputBtn() {
      console.log("号码为" + this.phone);
      // 手机号认证
      if (this.phone == "") {
        Toast("手机号不能为空");
      } else {
        const reg = /^1[2|3|4|5|6|7|8|9][0-9]\d{8}$/;
        console.log(reg.test(this.phone));
        if (reg.test(this.phone)) {
          // 发送请求
          setPhone({ ...this.userInfo, phone: this.phone }).then((res) => {
            if (res.code == 200) {
              // Toast("绑定成功");
              Dialog.confirm({
                title: "绑定成功",
                message: res.msg,
                theme: "round-button",
                showCancelButton: false,
              });
            } else {
              Dialog.confirm({
                title: "温馨提示",
                message: res.msg,
                theme: "round-button",
                showCancelButton: false,
              });
              // Toast(res.msg);
            }
          });
        } else {
          Toast("请输入正确的手机号");
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  margin: 0 auto;
  max-width: 1920px;
}

.aside_1 {
  width: 100%;
  min-height: 360px;
  // border: 1px solid red;
  overflow: hidden;
  .title {
    position: relative;
    top: 24%;
    font-size: 20px;
    line-height: 30px;
    // border: 1px solid red;
    width: 90%;
    margin: 0 auto;
    h1 {
      font-size: 24px;
      color: #ff3e4f;
      font-weight: 700;
      line-height: 60px;
      letter-spacing: 2px;
    }
    p {
      color: #545454;
      font-size: 22px;
      // margin-bottom: 10px
    }
  }

  .inp-box {
    margin-top: 40px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
  }

  .button {
    background: #ff3e4f;
    color: #fff;
    padding: 0 20px;
    border: none;
    font-size: 15px;
    margin: 20px;
    height: 50px;
    border-radius: 10px;
  }
  button:hover {
    cursor: pointer;
  }
}

/* 底部 */

footer {
  padding: 10px 0 30px 0;
  text-align: center;
  line-height: 30px;
  div {
    padding-top: 30px;
    margin: 0 auto;
    width: 80%;
    border-top: 1px dotted #5f5f5f;
    color: #a9a9a9;
    font-size: 8px;
  }
}

// 弹出层
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 200px;
  height: 200px;
  border-radius: 20px;
  overflow: hidden;
  // background-color: #fff;
}
</style>
